export default __webpack_public_path__ + "static/media/biblio-on.25b03534.svg";